import type { BudgetTypes } from 'src/App/pages/ad-budget-selection/mapBudgetOption';

import type { AdBudgetType, PricingModel } from '../../generated/graphql-types';

const mapAdBudgetTypeToTrackingBudgetType = (
  adBudgetType: AdBudgetType,
): BudgetTypes => {
  if (adBudgetType === 'CLASSIC_ONWARDS') {
    return 'FlexibleBudget';
  }
  if (adBudgetType === 'BRANDED_ONWARDS') {
    return 'BrandedBudget';
  }
  if (adBudgetType === 'PREMIUM_ONLY') {
    return 'PremiumBudget';
  }

  throw new Error(`unexpected budgetType: ${adBudgetType}`);
};

const mapAdBudgetType = (adBudgetType: AdBudgetType): string => {
  if (adBudgetType === 'CLASSIC_ONWARDS') {
    return 'contractClassic';
  }
  if (adBudgetType === 'BRANDED_ONWARDS') {
    return 'contractStandout';
  }
  if (adBudgetType === 'PREMIUM_ONLY') {
    return 'contractPremium';
  }

  throw new Error(`unexpected budgetType: ${adBudgetType}`);
};

const mapLegacyAdBudgetType = (adBudgetType: string): string => {
  if (adBudgetType === 'FlexibleBudget') {
    return 'contractClassic';
  }
  if (adBudgetType === 'BrandedBudget') {
    return 'contractStandout';
  }
  if (adBudgetType === 'PremiumBudget') {
    return 'contractPremium';
  }
  throw new Error(`unexpected budgetType: ${adBudgetType}`);
};

const mapPricingModel = (pricingModel: PricingModel): string => {
  switch (pricingModel) {
    case 'FIXED':
      return 'fixed';
    case 'HORIZON':
      return 'variable';
  }
};

export {
  mapAdBudgetType,
  mapLegacyAdBudgetType,
  mapPricingModel,
  mapAdBudgetTypeToTrackingBudgetType,
};
